<div class="transport-type-editor" [formGroup]="detailsFormGroup">
    <div class="row">
        <mat-form-field class="flex-grow">
            <mat-label>
                {{'transport type' |
                translate:['tmc-yard.widgets.filter-administration.details-editor.transport.transport-type-editor.transport-type',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="transportType" name="transportType">
                <mat-option *ngFor="let t of transportTypes" [value]="t">
                    {{t | translate: ['tmc-yard.entity.transport.transport-type.'+t, translationService.language]}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>